import { loadWidget } from '@sitevision/react';
import React from 'react';
import ReactDOM from 'react-dom';
import BenefitsAtAGlanceSection from './templates/molecules/benefitsataglance-section';

loadWidget('.plf-benefits-at-a-glance-area', benefitsAtAGlanceWidget => {
    const action = benefitsAtAGlanceWidget.dataset.action;
    ReactDOM.render(<BenefitsAtAGlanceSection action={action} />, benefitsAtAGlanceWidget);
});
